import { render, staticRenderFns } from "./IconSvgTraForkKnifeDrk.vue?vue&type=template&id=a149baf2&scoped=true&"
import script from "./IconSvgTraForkKnifeDrk.vue?vue&type=script&lang=js&"
export * from "./IconSvgTraForkKnifeDrk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a149baf2",
  null
  
)

export default component.exports